import * as yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'

const messages = defineMessages({
  required: {
    id: 'passengerType.form.new.required',
    defaultMessage: 'This field is required'
  },
  descriptionMax: {
    id: 'passengerType.form.new.description.max',
    defaultMessage: 'The description can be up to 20 characters'
  },
  labelMax: {
    id: 'passengerType.form.new.label.max',
    defaultMessage: 'The label can be up to 20 characters'
  },
  abbreviationMax: {
    id: 'passengerType.form.new.abbreviation.max',
    defaultMessage: 'The abbreviation can be up to 4 characters'
  }
})

const LABEL_MAX_LENGTH = 20

export const schema = (intl: IntlShape): yup.AnySchema => {
  return yup.object().shape({
    countryCode: yup.string().required(intl.formatMessage(messages.required)),
    discount: yup.string().required(intl.formatMessage(messages.required)),
    passengerType: yup.string().required(intl.formatMessage(messages.required)),
    salesChannels: yup.array().min(1, intl.formatMessage(messages.required)),
    enLabel: yup
      .string()
      .max(LABEL_MAX_LENGTH, intl.formatMessage(messages.labelMax))
      .required(intl.formatMessage(messages.required)),
    esLabel: yup
      .string()
      .max(LABEL_MAX_LENGTH, intl.formatMessage(messages.labelMax))
      .required(intl.formatMessage(messages.required)),
    enLabelPlural: yup
      .string()
      .max(LABEL_MAX_LENGTH, intl.formatMessage(messages.labelMax))
      .required(intl.formatMessage(messages.required)),
    esLabelPlural: yup
      .string()
      .max(LABEL_MAX_LENGTH, intl.formatMessage(messages.labelMax))
      .required(intl.formatMessage(messages.required)),
    enAbbreviation: yup
      .string()
      .max(4, intl.formatMessage(messages.abbreviationMax))
      .required(intl.formatMessage(messages.required)),
    esAbbreviation: yup
      .string()
      .max(4, intl.formatMessage(messages.abbreviationMax))
      .required(intl.formatMessage(messages.required)),
    enDescription: yup.string().max(20, intl.formatMessage(messages.descriptionMax)),
    esDescription: yup
      .string()
      .max(20, intl.formatMessage(messages.descriptionMax))
      .when('enDescription', {
        is: (enDescription: string) => enDescription?.length > 0,
        then: yup.string().required(intl.formatMessage(messages.required))
      })
  })
}
